import React from 'react';

const Northdakota = () => {
  return (
    <div>
      
    </div>
  );
}

export default Northdakota;
